export enum OfferUserStatusEnum {
  Inactive = 1,
  InProgress,
  Active,
}
